import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEye = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M32 54.4C49.6731 54.4 64 32 64 32C64 32 49.6731 9.60001 32 9.60001C14.3269 9.60001 0 32 0 32C0 32 14.3269 54.4 32 54.4ZM31.8998 16.1049L36.6589 16.8028H36.6599C39.2592 17.1843 41.6006 18.5827 43.1692 20.6902L46.0408 24.5489C47.6094 26.657 48.2765 29.3014 47.895 31.9007L47.1971 36.6599C46.8156 39.2592 45.4173 41.6005 43.3097 43.1691L39.451 46.0407C37.343 47.6093 34.6985 48.2765 32.0992 47.8949L27.3401 47.197C24.7408 46.8155 22.3994 45.4172 20.8308 43.3096L17.9592 39.4509C16.3906 37.3429 15.7235 34.6985 16.105 32.0992L16.8029 27.34C17.1839 24.7407 18.5823 22.3988 20.6893 20.8307L24.548 17.9591C26.656 16.3905 29.3005 15.7234 31.8998 16.1049Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgEye);
export default ForwardRef;
